module.exports = __webpack_public_path__ + "static/media/distances_GO_C.2a3b8595.csv";